import { OrderReturnDetailProps } from 'components/LightConversation/types';
import { ReturnOrderListItemV2 } from 'services/api/refund';
import { toUpperCase } from 'utils/toLowerCase';
import { OrderReturnInfo } from './OrderReturnInfo';
import { OrderReturnReason } from './OrderReturnReason';
import { CommentCard } from '../OrderDetail/CommentCard';
import { OrderQueryParams } from 'hooks/business/chat/useOrderList';
import { OrderReturnItems } from './OrderReturnItems';
import { OrderReturnHistory } from './OrderReturnHistory';
import { useEffect, useMemo } from 'react';
import { isTiKTok } from 'lib/utils/isTikTok';
import { LazadaOrderReturnItems } from './LazadaOrderReturnItems';
import { UseLazadaReturnOpsReturn } from 'hooks/business/chat/useLazadaReturnOps';
import { useLazadaOrderReturnDetailContext } from './context';

export interface OrderReturnDetailContentProps extends OrderReturnDetailProps {
  returnOrder: ReturnOrderListItemV2;
  /** 用于乐观更新的查询参数 */
  orderQueryParams?: OrderQueryParams;
  lazadaReturnOps: UseLazadaReturnOpsReturn;
}

export const OrderReturnDetailContent = (props: OrderReturnDetailContentProps) => {
  const { order, returnOrder, orderQueryParams, lazadaReturnOps } = props;
  const { platform: orderPlatform, unit, items } = order;
  const { returnItemData, refundAmount, returnSn } = returnOrder;

  const platform = toUpperCase(orderPlatform);
  const { clearCheckReturnOrderItemIds } = useLazadaOrderReturnDetailContext();

  const isLazada = platform === 'LAZADA';

  const returnHistory = useMemo(() => {
    if (isTiKTok(platform)) {
      return items.flatMap(
        (item) =>
          item.refundReason?.find((refundReason) => refundReason.returnSn === returnSn)
            ?.returnHistory ?? [],
      );
    }
    return [];
  }, [platform, items, returnSn]);

  useEffect(() => {
    return () => {
      clearCheckReturnOrderItemIds();
    };
  }, [clearCheckReturnOrderItemIds, returnSn]);

  return (
    <div className="flex flex-col gap-4">
      <OrderReturnInfo platform={platform} returnOrder={returnOrder} />
      <OrderReturnReason platform={platform} returnOrder={returnOrder} />
      {isLazada ? (
        <LazadaOrderReturnItems
          platform={platform}
          unit={unit}
          returnItems={returnItemData}
          returnSn={returnSn}
          lazadaReturnOps={lazadaReturnOps}
        />
      ) : (
        <OrderReturnItems
          platform={platform}
          unit={unit}
          returnItems={returnItemData}
          refundAmount={refundAmount ?? 0}
        />
      )}
      <CommentCard order={order} queryParams={orderQueryParams} />
      {returnHistory.length > 0 && (
        <OrderReturnHistory returnHistory={returnHistory} platform={platform} />
      )}
    </div>
  );
};
